import { useState } from 'react';
import { FinancialWellnessCarousel, HubspotBrochureDownload } from '.'

const AZWellnessGuide = (props) => {
    return (
        <>
		<section className="contentmainN ptb0">
			<div className="container customCampaignContainer">
				<div className="row d-flex align-items-center">
					<div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 ">
                        <div className="subTextHeading text-left">You will get to learn:</div>
                        <div>
                            <ul className="mainbullets mt-4">
                                <li>Financial wellness and its importance in the workplace.</li>
                                <li>How can employers assist in addressing the factors impacting financial wellness?</li>
                                <li>How does financial stress among employees affect absenteeism and productivity?</li>
                                <li>Some significant statistics of financial wellness and its impact on retirement readiness.</li>
                                <li>How have employers recognized its importance, and what benefits do they offer?</li>
                            </ul>
                        </div>
					</div>
					<div  className="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-center" id="implementationCarousel">
					<FinancialWellnessCarousel/>
					</div>
				</div>
			</div>
		</section>
		<div id="downloadForm"></div>
		<section className="sectionSpacing" >
			<div className="container customCampaignContainer">
				<div className="row">
					<div className="col-md-6 col-md-offset-2  col-sm-offset-2 col-xs-12 col-sm-12 col-lg-6 col-lg-offset-2 text-center shadow" style={{margin:"auto", borderRadius:"16px", padding:"60px 30px"}}>
						<div className="mainHeadingN ">Download Now</div>
						<div className="innerSpace">
						<HubspotBrochureDownload formID="d5011a99-e639-40de-8ae3-6d431607e6e6"/>
						</div>
					</div>
					
				</div>
			</div>
		</section>
        </>
    );
}

export default AZWellnessGuide;



